const releaseInfo = {
    buildId: '1.6.13',
    name: 'Atlas',
    commit: '40d80558e9dd280422a6b1a667151da075792156'
};
export default releaseInfo;
